const authConfig = {
  loginEndpoint: "/login_check",
  storageTokenKeyName: "accessToken",
};
export const LoginErrorMessage =
  "Une erreur est survenue.\nVeuillez vous reconnecter.";
export const refreshTokenError = "refreshTokenError";
export const credentialsSignin = "CredentialsSignin";
export default authConfig;
